import { get, patch, post, remove } from "../../service/axios";
import qs from "qs";

interface DeviceQueryOptions {
  limit?: number;
  offset?: number;
  search?: string;
  status?: string;
  date_after?: string;
  date_before?: string;
  target_device?: string;
}

export async function apiGetOrders(options: DeviceQueryOptions = {}) {
  const { limit, offset, search, status, date_after, date_before, target_device } = options;
  const params: Record<string, any> = {
    ...(limit !== undefined ? { limit } : {}),
    ...(offset !== undefined ? { offset } : {}),
    ...(target_device ? { target_device } : {}),
    ...(date_after ? { date_after } : {}),
    ...(date_before ? { date_before } : {}),
    ...(search
      ? { search: search.includes(" ") ? `"${search.trim()}"` : search.trim() }
      : {}),
    ...(status !== "" ? { status } : {}),
  };

  return get("/orders/", {
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
}

export async function apiGetOrderDetail(id: string) {
  return get(`/orders/${id}/`);
}

export async function apiCreateOrder(props: any) {
  return post(`/orders/`, props);
}

export async function apiEditOrder(id: number, props: any) {
  return patch(`/orders/${id}/`, props);
}

export async function apiDeleteOrder(id: number) {
  return remove(`/orders/${id}/`);
}

export async function apiGetOrdersDashboard() {
  return get(`/orders/dashboard/`);
};

export async function apiGetFailedOrders() {
  return get(`/orders/recently-failed/`);
};

export async function apiGetDeviceSelectors() {
  return get(`/selectors/devices/devices/`);
};

export async function apiSendorder(id: string, device?: string) {
  return post(`/orders/${id}/send/`, {
    ...(device && { device })
  });
};
